var getRenderProperties = {};
export {
  getRenderProperties as __exports
};
//# sourceMappingURL=index150.js.map
